import GroupQrPrint from './GroupQrPrint'

export default GroupQrPrint
